import React from 'react'
import '../styles/style.css'
import shortcut from '../images/shortcut.svg'
import error from '../images/error.svg'
import tick from '../images/tick.svg'
import cancel from '../images/cancel.svg'


class PopupBottomSub extends React.Component {
    render() {

        return (
            <div className="modal-bottom">
                <div className="modal-content-bottom pad-bottom">
                    <div className="modal-header">
                        <img src={this.props.flag=="S"? tick: error}></img>
                     {this.props.showCross?<img src={cancel} onClick={() => this.props.closePopup('Ok')}></img>
                    :null}
                    </div>
                    <div className="modal-main">
                        <p>{this.props.heading}</p>
                        <p>{this.props.message}</p>
                        <p className="subMessage1">{this.props.submessage}</p>
                        <button className="subs"   onClick={() => this.props.closePopup(this.props.button)}>{this.props.button}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default PopupBottomSub;